import api from '../../api'

const syncOptionList = [
  { label: '只同步库存', value: 1 },
  { label: '只同步价格', value: 2 },
  { label: '两个都同步', value: 0 }
]

const goodsOptionList = [
  { label: '全部商品', value: 'all-goods' },
  { label: '只同步售卖中', value: 'only-up-goods' }
]

const selectGoodsOptionList = [
  { label: '根据指定页码', value: 'page' },
  { label: '根据勾选的', value: 'select' }
]

const SyncGoodsPriceAndStock = async (This, { list, type, templateRef, isSyncDown }, logCb) => {
  const { params, goodsTemplateList } = templateRef
  logCb(' ———————————————————————————————————————————————————————', true)
  for (let i = 0; i < list.length; i++) {
    // 如果日志弹出框关闭了就不需要再执行下去
    if (!This.isShowLogModal) break
    const item = list[i]
    const tempId = goodsTemplateList.find(t => t.id === item.TempId) ? item.TempId : params.id
    // 先固定使用选择商品模板而不是 商品之前创建的时候用的模板
    const { msg, success } = await api.SyncGoodsPriceAndStock({ 
      moveLogId: item.Id,
      tempId: params.id || tempId, 
      type, 
      isSyncDown
    })
    logCb(` 第【${i + 1}】个商品，上游商品ID:【${item.OutGoodsId}】，支付宝商品ID:【${item.GoodsId}】，同步${This.getFinalText}${success ? `成功，${msg}` : `失败，原因:【${msg}】`}`)
    logCb(' ———————————————————————————————————————————————————————', true)
  }
}

// 根据页码获取铺货成功的上货记录
const GetLogList = async ({ page, size }) => {
  let newList = []
  for (let i = page; i <= size; i++) {
    const { list } = await api.GetLogList({ page: i, size: 100, status: 2, type: 5 })
    if (!list.length) break
    newList = [...newList, ...list]
  }
  if (!newList.length) return { msg: `第【${page}】页 到 第【${size}】中没有铺货成功的支付宝商品` }
  return { list: newList }
}

export default {
  syncOptionList, goodsOptionList, selectGoodsOptionList, SyncGoodsPriceAndStock, GetLogList
}